import styled from 'styled-components';
import { FunctionComponent } from 'react';
import { TriangleUpIcon } from '@primer/octicons-react';
import { isMobile } from 'react-device-detect';
import { showContactForm } from '../../redux/slices/modal.slice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { useGetSubscriptionStatusQuery } from '../../redux/apis/payment';
import { selectAuth } from '../../redux/slices/auth.slice';
import { setCookieConsentVisible } from '../../redux/slices/cookieConsent.slice';

const ClickField = styled('div')`
  position: relative;
  color: blue;
`;

const Item = styled('button')`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 10px 12px;
  border-radius: 12px;
  color: hsla(263, 50%, 12%, 0.8);
  font: 500 14px var(--font-body);
  background: white;
  border: 0px;
  cursor: pointer;
  transition: color 150ms, background-color 150ms;

  &:hover {
    color: var(--primary);
    background: var(--secondary);
  }
`;

export const MoreMenu: FunctionComponent<{
  readonly setClose: any;
  readonly leftPosition: number;
}> = ({ setClose, leftPosition }) => {
  const dispatch = useAppDispatch();
  const { isLoggedIn, isGuest } = useAppSelector(selectAuth);
  const sub = useGetSubscriptionStatusQuery(undefined, { skip: !isLoggedIn || isGuest });

  return (
    <ClickField
      onClick={(e) => {
        isMobile ? setClose() : null;
      }}
      onPointerLeave={(e) => {
        !isMobile ? setClose() : null;
      }}
      style={{
        width: '300px',
        height: '300px',
        top: isMobile ? '0px' : '40px',
        position: 'absolute',
        left: leftPosition,
        padding: '0px',
        zIndex: 100,
      }}
    >
      <div
        style={{
          top: '15px',
          paddingLeft: '14px',
          width: '210px',
          position: 'absolute',
          left: '30px',
          background: '#fff',
          borderRadius: '16px',
          padding: '12px',
          boxShadow: 'var(--shadow-card)',
          border: '1px solid var(--border)',
          zIndex: 12,
        }}
      >
        {/* <Item
          onClick={() => {
            window.open('https://go.cozyjuicyreal.com/wa-store');
            setClose();
          }}
        >
          FAQ's
        </Item> */}
        <Item
          onClick={() => {
            dispatch(showContactForm());
            setClose();
          }}
        >
          Send feedback
        </Item>
        {!isLoggedIn ||
        isGuest ||
        sub.data?.find(
          (s) => s.isSubscriptionActive && !s.isTemporaryAddOnSubscription && s.plan == 'FREE'
        ) ? (
          <Item
            onClick={() => {
              window.open('https://cozyjuicyreal.com', '_blank', 'noreferrer');
              setClose();
            }}
          >
            Team building
          </Item>
        ) : null}
        <Item
          onClick={() => {
            window.open('https://cozyjuicyreal.com/shop', '_blank', 'noreferrer');
            setClose();
          }}
        >
          Buy the board game
        </Item>
        {!isLoggedIn ||
        isGuest ||
        sub.data?.find(
          (s) => s.isSubscriptionActive && !s.isTemporaryAddOnSubscription && s.plan !== 'FREE'
        ) ? (
          <Item
            onClick={() => {
              window.open('https://cozyjuicyreal.com/contact', '_blank', 'noreferrer');
              setClose();
            }}
          >
            Contact us
          </Item>
        ) : null}
        {!isLoggedIn ||
        isGuest ||
        sub.data?.find(
          (s) => s.isSubscriptionActive && !s.isTemporaryAddOnSubscription && s.plan !== 'FREE'
        ) ? (
          <Item
            onClick={() => {
              localStorage.removeItem('cookieConsent');
              dispatch(setCookieConsentVisible(true));
              setClose();
            }}
          >
            {/* <Icon src={emoji} /> */}
            Manage Cookies
          </Item>
        ) : null}
        {/*         <Item
          onClick={() => {
            window.open('https://go.cozyjuicyreal.com/wa-discord');
            setClose();
          }}
        >
          Join community
        </Item> */}
      </div>
      <div
        style={{
          position: 'absolute',
          top: isMobile ? '-25px' : '-15px',
          left: '55px',
          zIndex: 12,
        }}
      >
        <TriangleUpIcon fill="white" size={50} />
      </div>
    </ClickField>
  );
};
